import { Controller } from '@hotwired/stimulus'

export default class AnimateUnderlineController extends Controller {
  static targets = ['button'];

  updateView(event) {
    if (!document.startViewTransition) {
      this.updateActiveTab(event.target);
    }
    document.startViewTransition(() => this.updateActiveTab(event.target));
  }

  updateActiveTab = (tab) => {
    this.removeSliders();
    this.addActiveSlider(tab);
  }

  removeSliders = () => this.buttonTargets.forEach((tab) => {
    tab.querySelector('.slider')?.remove();
  });

  addActiveSlider = (tab) => {
    const slider = document.createElement('span');
    slider.classList.add('slider');
    tab.appendChild(slider);
  };
}
